module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-fototeca-immagine gv-inverted-color-scheme",
    attrs: {
      "id": "gv-fototeca-immagine"
    }
  }, [_vm._c('gv-title', {
    directives: [{
      name: "draggable",
      rawName: "v-draggable"
    }],
    attrs: {
      "title": _vm.title,
      "divId": 'gv-fototeca-immagine'
    }
  }), _vm._v(" "), _vm._c('el-button', {
    staticClass: "gv-color-scheme gv-button-fototeca-immagine-carrello",
    attrs: {
      "id": "gv-button-fototeca-immagine-carrello",
      "icon": "el-icon-circle-plus-outline",
      "title": "Aggiungi al Carrello",
      "size": "mini"
    },
    on: {
      "click": _vm.addToBasket
    }
  }, [_vm._v("Aggiungi al Carrello")]), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-fototeca-immagine-body",
    attrs: {
      "id": "gv-fototeca-immagine-body"
    }
  }, [_vm._c('image-viewer', {
    attrs: {
      "imgUrl": _vm.imgUrl,
      "logo": _vm.logo,
      "width": "400",
      "height": "400"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e584568!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FototecaImmagine.vue
// module id = 862
// module chunks = 39